import styled from "styled-components";
import { ConsignmentTrackingControl } from "../../../../oceanTracking/TrackingPanel";

const TrackDetailsButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 0;
  color: #2060ea;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  text-transform: uppercase;

  &:hover:not(:disabled) {
    color: #2060ea;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export function ShipmentTrackerCell({ order, onTrackingUpdated }) {
  if (!order?.id) {
    return <td key="tracker" />;
  }

  return (
    <td
      key="tracker"
      onClick={event => event.stopPropagation()}
      onKeyDown={event => event.stopPropagation()}
    >
      <ConsignmentTrackingControl
        consignment={order.id}
        shipmentNumber={order.name}
        onTrackingUpdated={onTrackingUpdated}
        deferQuery
        initialHasTracking={order.has_ocean_tracking}
        renderTrigger={({ disabled, hasTracking, label, onClick }) => (
          <TrackDetailsButton
            type="button"
            disabled={disabled}
            title={label}
            onClick={onClick}
          >
            {hasTracking ? "Show Tracker" : "Track"} <span aria-hidden="true">→</span>
          </TrackDetailsButton>
        )}
      />
    </td>
  );
}
